import { render, staticRenderFns } from "./CollaborateurCard.vue?vue&type=template&id=4fa1bb73&scoped=true&"
import script from "./CollaborateurCard.vue?vue&type=script&lang=js&"
export * from "./CollaborateurCard.vue?vue&type=script&lang=js&"
import style0 from "./CollaborateurCard.vue?vue&type=style&index=0&id=4fa1bb73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa1bb73",
  null
  
)

export default component.exports